import { useEffect, useRef, useMemo } from 'react';
import Cookie from 'js-cookie';
import { playSound } from '../../utils/soundUtils';
import successSound from '../../public/assets/sounds/success.mp3';
import errorSound from '../../public/assets/sounds/error.mp3';
import notificationSound from '../../public/assets/sounds/notification.mp3';
import sendMessageSound from '../../public/assets/sounds/sendingMessage.mp3';
import receiveMessageSound from '../../public/assets/sounds/receivingMessage.mp3';
const audio = {
    success: successSound,
    error: errorSound,
    notification: notificationSound,
    sendMessage: sendMessageSound,
    receiveMessage: receiveMessageSound
};
const Sound = ({ type, play, setPlay }) => {
    const enable_audio = useMemo(() => {
        const userCookie = Cookie.get('user');
        if (!userCookie)
            return false;
        try {
            return JSON.parse(userCookie)?.details?.audio || false;
        }
        catch {
            return false;
        }
    }, []);
    const audioSource = type ? (audio[type] ?? audio.notification) : null;
    const audioRef = useRef(null);
    useEffect(() => {
        if (!enable_audio || !audioSource)
            return;
        const cleanup = playSound(audioSource, audioRef, play, setPlay);
        return cleanup;
    }, [play, audioSource, setPlay, enable_audio]);
    return null;
};
export default Sound;
